import {Listener} from "./listener";
import {UtilService} from "./utils";
import message from "@/service/message";
import {Category} from "@/libs";

function replaceDownloadUrl(url: string) {
  let urlPath = url.split("/");
  let newDomain = "";
  const $url = (window as any).$url;
  switch (urlPath[2]) {
    case "img.maidiyun.com":
      newDomain = $url.img;
      break;
    case "downs3.maidiyun.com":
      newDomain = $url.downs3;
      break;
    case "pdmapi.maidiyun.com":
      newDomain = $url.pdmapi;
      break;
    case "apicommon.maidiyun.com":
      newDomain = $url.rs;
      break;
  }
  if (!newDomain) return url;
  urlPath.splice(0, 3);
  urlPath.unshift(newDomain);
  return urlPath.join("/");
}

export class WinForm {
  //---------------------window.md
  static md = {
    /**
     * 打开弹出窗口
     * @param callback 打开窗口完毕后的回调，js的function名称
     * @param isBackground 是否后台静默打开
     */
    openWindow(url: string, width: number, height: number, callback?: any, loadingImage: string | null = null, isModal: boolean = false) {
      return ((parent.window || window) as any).md.openWindow(url, width, height, callback, loadingImage, isModal);
    },
    /**
     * 后台静默创建一个隐藏窗口，且不会展示
     *
     */
    initWindow(url: string, title: string, width: number, height: number) {
      return ((parent.window || window) as any).md.initWindow(url, title, width, height);
    },

    showWindow(url: string) {
      return (window as any).md.showWindow(url);
    },


    /**
     * 打开聊天窗口
     * @returns 
     */
    openChatTab() {
      if(this.chatTabIsOpened()) return;
      return ((parent.window || window) as any).md.openChatTab();
    },

    /**
     * 判断聊天窗口是否打开
     * @returns 
     */
    chatTabIsOpened() {
      return ((parent.window || window) as any).md.chatTabIsOpened();
    },

    /**
     * 在主窗口创建或激活指定tabId的页签
     * @param tabId 页签的唯一标识，不传时会自动加guid
     * @param lazyLoad true时只加页签，当激活页签时才会加载内容
     * @param active -1 强制随配置 0随配置 1强制不激活 2强制激活
     */
    openTab(
      url: string,
			title: string = "",
			icon: string = "",
			tabId: string = "",
			notAllowClose: boolean = false,
			width: number = 0,
			lazyLoad: boolean = false,
			active: boolean = true
    ) {
      return ((parent.window || window) as any).md.openTab(url, title, icon, tabId, notAllowClose, active);
    },

    /**
     * 关闭指定tabId的页签
     * @param tabId 页签的唯一标识
     */
    closeTab(tabId: string = "") {
      return ((parent.window || window) as any).md.closeTab(tabId);
    },
    /**
     * 在外部浏览器中打开url地址
     * @param url
     */
    openUrl(url: string) {
      return ((parent.window || window) as any).md.openUrl(url);
    },

    /**
     * 打开文件选择窗口
     * failed失败；其他为文件全路径
     */
    openFileDlg(multi: boolean = false, filter: string = "", defaultPath: string = "") {
      return ((parent.window || window) as any).md.openFileDlg(multi, filter, defaultPath);
    },

    /**
     * 打开目录选择窗口
     * 返回：failed失败；其他为目录路径
     */
    openDirectoryDlg(defaultPath: string = "") {
      return ((parent.window || window) as any).md.openDirectoryDlg(defaultPath);
    },

    /**
     *保存文件窗口
     * failed失败；其他为文件全路径
     */
    saveFileDlg(filter: string = "", defaultPath: string = "", fileName: string = "") {
      return ((parent.window || window) as any).md.saveFileDlg(filter, defaultPath, fileName);
    },
    //返回拖拽文件路径
    getDragFiles(): { Path: string, FileType: number }[] {
      let files = ((parent.window || window) as any).md.getDragFiles()
      return JSON.parse(files).filter((_file: any) => _file.FileType === 1 || _file.FileType === 2);
    },
    /**
     * 下载文件
     * @param progress (参数：downloadId,进<1-100>,速度<字节>,状态值,状态描述)：下载进度回调，js的function方法
     * @param downloadId 下载任务唯一编号，一般不传，但是对于已经在下载队列中的，可以将队列的downloadId直接传入
     * 下载任务的唯一编号
     */
    download(url: string, filepath: string, downloadId: string = "", progress: any, isThunderRetry = true) {
      url = replaceDownloadUrl(url);
      let isnet = WinForm.storge.get("isnet");
      if (isnet) {//如果是外网
        url.startsWith("//") && (url = location.protocol + url);
      } else {//如果是内网
        if (url.startsWith("//")) {
          url = "http:" + url;
        } else if (url.startsWith("https:")) {
          url = url.replace("https", "http");
        }
      }
      let fnName = "download_" + (downloadId || UtilService.Guid());
      Listener.remove(fnName);
      Listener.add(fnName, progress);
      // console.log(url, filepath, fnName, downloadId, isThunderRetry);
      return ((parent.window || window) as any).md.download2(url, filepath, fnName, downloadId, isThunderRetry);
    },
    /**
     *暂停下载
     * 没有返回值  会进入下载进度的函数中
     */
    pauseDownload(downloadId: string = "") {
      ((parent.window || window) as any).md.pauseDownload(downloadId);
    },
    /**
     *恢复下载
     * 没有返回值  会进入下载进度的函数中
     */
    resumeDownload(downloadId: string = "", progress: any) {
      let fnName = "download_" + downloadId;
      Listener.add(fnName, progress);
      ((parent.window || window) as any).md.resumeDownload(downloadId);
    },
    /**
     *取消下载
     * 没有返回值  会进入下载进度的函数中
     * deleteTempFile 是否删除临时文件 默认不删除
     */
    cancelDownload(downloadId: string = "", deleteTempFile: boolean = false) {
      ((parent.window || window) as any).md.cancelDownload(downloadId, deleteTempFile);
    },


    /**
     *检测文件是否存在
     * failed失败；其他为是否存在的布尔值
     */
    existFile(filePath: string = "") {
      return ((parent.window || window) as any).md.existFile(filePath);
    },

    /**
     *打开文件夹
     * failed失败；
     */
    openDirectory(directory: string = "") {
      return ((parent.window || window) as any).md.openDirectory(directory);
    },

    /**
     *打开文件
     * failed失败；
     */
    openFile(directory: string = "") {
      return ((parent.window || window) as any).md.openFile(directory);
    },

    /**
     * 激活对应的面板
     * @param key Setup设置页面
     * @returns 
     */
    activeTab(key: 'Setup') {
      if (!key) return false;
      return ((parent.window || window) as any).md.activeTab(key)
    },

    /**
     * 获取当前窗口的状态
     * @returns Normal = 0,Minimized = 1,Maximized = 2
     */
    getWindowState() : 0 | 1 | 2 {
      return ((parent.window || window) as any).md.getWindowState();
    },

    /**
     * 获取当前激活tab的索引
     * @returns 
     */
    getTabIndex(): number {
      return ((parent.window || window) as any).md.getTabIndex();
    },

    /**
     *  获取本地文件信息
     *  入参支持相对路径
     */
    getFileInfo(filePath: string = "") {
      let fileJson = ((parent.window || window) as any).md.getFileInfo(filePath);
      return fileJson ? JSON.parse(fileJson) : "";
    },

    /**
     * 跨页监听事件
     */
    $on(eventName: string, event: any) {
      Listener.add(eventName, (args: string) => {
        try {
          args = JSON.parse(args);
          event(args)
        } catch (e) {
          event(args)
        }
      });
      ((parent.window || window) as any).md.onListen(eventName);
    },

    /**
     * 跨页触发事件
     */
    $emit(event: string, args: any = "", self: boolean = true) {
      if (self) {
        const fn = ((parent.window || window) as any)[event];
        fn && fn(JSON.stringify(args));
      }
      ((parent.window || window) as any).md.emit(event, JSON.stringify(args));
    },

    /**
     * 上传文件
     * @params filePath文件物理路径
     * @params progress 上传的回调 会返回进度 返回参数和下载返回的参数一致
     *
     */
    upload(filePath: string, signatureStr: any = {}, contentType: string = "application/octet-stream", progress: Function, uploadId: string = "") {
      let fnName = "upload_" + (uploadId || UtilService.Guid());
      Listener.add(fnName, progress);
      return ((parent.window || window) as any).md.upload(filePath, JSON.stringify(signatureStr), contentType, fnName, uploadId);
    },

    /**
     * 取消上传文件
     */
    cancelUpload(uploadId: string = "") {
      ((parent.window || window) as any).md.cancelUpload(uploadId);
    },
    /**
     *  获取文件Hash
     *  入参支持相对路径
     */
    getFileHash(directory: string = "") {
      return ((parent.window || window) as any).md.getFileHash(directory);
    },
    /**
     *  获取字符串的MD5  基座获取和前端服务获取的不一致 两方共用的 md5 使用基座的方法获取
     *  入参支持相对路径
     */
    getMD5Hash(string: string = "") {
      return ((parent.window || window) as any).md.getMD5Hash(string);
    },

    /**
     * 下载文件   下载改版   暂时增加download2
     * @param progress (参数：downloadId,进<1-100>,速度<字节>,状态值,状态描述)：下载进度回调，js的function方法
     * @param downloadId 下载任务唯一编号，一般不传，但是对于已经在下载队列中的，可以将队列的downloadId直接传入
     * 下载任务的唯一编号
     */
     download2(url: string, filepath: string, downloadId: string = "", progress: any,isThunderRetry:boolean=false) {
      url = replaceDownloadUrl(url);
      url.startsWith("//") && (url = location.protocol + url);
      return ((window || window) as any).md.download2(url, filepath, UtilService.RegisterWinFunc(progress), downloadId,isThunderRetry);
    },

    /**
     * 获取应用程序安装 磁盘 格式   D:
    */
    getAppPath_Disk() {
      let appPath = ((parent.window || window) as any).md.getAppPath();
      return appPath.substr(0, 2)
    },
  };

  static frame = {
    /**
     * 激活指定页签（禁用）
     */
    activeTabContent(key: string) {
      return ((parent.window || window) as any).frame.activeTabContent(key);
    },

    /**
     *   移除指定页签的内容（禁用）
     * @param key
     */
    removeTabContent(key: string) {
      return ((parent.window || window) as any).frame.removeTabContent(key);
    },

    /**
     * 刷新当前页面
     */
    refresh() {
      return ((parent.window || window) as any).frame.refresh();
    },

    /**
     * 注册主窗口最大化、还原、最小化事件监听事件
     * @param event js端接收function，仅有一个state参数，表示变化后的状态：0normal 1min 2max
     */
    regWindowState(event: Function) {
      let key = "windowState_" + UtilService.Guid();
      Listener.add(key, event);
      return ((parent.window || window) as any).frame.regWindowState(key);
    },

    /**
     * 将主窗口最大化
     */
    max() {
      return ((parent.window || window) as any).frame.max();
    },

    /**
     * 将主窗口最小化
     */
    min() {
      return ((parent.window || window) as any).frame.min();
    },

    /**
     * 将主窗口还原
     */
    normal() {
      return ((parent.window || window) as any).frame.normal();
    },

    /**
     * 将主窗口关闭
     */
    close() {
      return ((parent.window || window) as any).frame.close();
    }
  };

  //----------------window.storge
  static storge = {
    /**
     * 设置指定关键字的内容
     * @param groupId 分组编号，可空，用于将键值对分组管理
     */
    set(key: string, value: any, groupId: string = "") {
      return ((parent.window || window) as any).storge.set(key, JSON.stringify(value), groupId);
    },

    /**
     *  获取指定关键字的内容
    */
    get(key: string, groupId: string = "") {
			const result = ((window || window) as any).storge.get(key, `${groupId}`);
      let endData = '';
      try {
        endData = JSON.parse(result);
        typeof endData === 'string' && (endData = JSON.parse(endData));
      } catch (e) {
        return result;
      }
      return endData;
		},

    /**
     * 获取指定分组的键值对列表（已经将value值json化）
     * 输出：[{id,key,value}]
     */
    list(groupId: string, page: number = 1, count: number = 20) {
      return JSON.parse(((parent.window || window) as any).storge.list(groupId, page, count));
    },

    /**
     *  移除分组列表返回的指定值
     */
    remove(id: string) {
      return ((parent.window || window) as any).storge.remove(id);
    },

    localAdd(key: string, value: any) {
      return (window as any).localStorage.setItem(key, JSON.stringify(value));
    },
    localGet(key: string, once: boolean = false) {
      let value = (window as any).localStorage.getItem(key);
      try {
        value = JSON.parse(value);
      } catch (error) {}
      once && (window as any).localStorage.removeItem(key);
      return value
    },
  };

  static dlg = {
    /**
     * 关闭弹窗
     * @param result
     */
    close(result: string = "") {
      return ((parent.window || window) as any).dlg.close(result);
    },
    /**
     * 激活当前调用方法的窗口
     */
    activate() {
      return ((parent.window || window) as any).dlg.activate();
    }


  };

  static lan = {
    /**
     *  启动代理服务（成功登陆后）
     */
    startProxy(userId: string) {
      return ((parent.window || window) as any).lan.startProxy(userId);
    },

    /**
     *  探查代理服务器（确认没有互联网时）
     */
    searchProxy(searchComplete: string) {
      return ((parent.window || window) as any).lan.searchProxy(searchComplete);
    },

    /**
     * 上线
     */
    online(userId: string) {
      return ((parent.window || window) as any).lan.online(userId);
    }
  };

  //---------------window.im
  static im = {
    /**
     *登录云通讯
     */
    Login(userId: string, loginChanged: string) {
      //todo winform确定之后记得更改
      return ((parent.window || window) as any).im.Login(userId, loginChanged);
    },

    /**
     *   注册登录状态变化事件
     */
    registerReceiveEvent(messageReceive: string) {
      //todo winform确定之后记得更改
      return ((parent.window || window) as any).im.registerReceiveEvent(messageReceive);
    },

    /**
     * 发送文本消息
     */
    sendText(text: string, userId: string) {
      //todo winform确定之后记得更改
      return ((parent.window || window) as any).im.sendText(text, userId);
    },

    /**
     * 创建群组
     * @param complete ('0/1','{groupId}', '{描述，比如错误描述}')：命令执行完毕后的回调，下同。
     */

    createGroup(groupName: string, scope: number = 300, complete?: Function) {
      let key = "createGroup_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.sendText(groupName, scope, key);
    },

    /**
     * 解散群组
     */
    dismissGroup(groupKey: string, complete?: Function) {
      let key = "dismissGroup_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.dismissGroup(groupKey, key);
    },

    /**
     *  主动加人入群（无需验证  ）
     */
    inviteJoinGroup(groupKey: string, userIdArray: string[], complete?: Function) {
      let key = "inviteJoinGroup_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.inviteJoinGroup(groupKey, JSON.stringify(userIdArray), key);
    },
    /**
     * 将人剔出群
     */
    deleteGroupMember(groupKey: string, userId: string, complete?: Function) {
      let key = "deleteGroupMember_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.deleteGroupMember(groupKey, userId, key);
    },

    /**
     *   主动退群
     */
    quitGroup(groupKey: string, complete?: Function) {
      let key = "quitGroup_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.quitGroup(groupKey, key);
    },

    /**
     * 设置群成员角色,1群主 2管理员 3成员
     * @param string
     */
    setGroupMemberRole(groupKey: string, userId: string, role: number = 2, complete?: Function) {
      let key = "setGroupMemberRole_" + UtilService.Guid();
      Listener.add(key, complete);
      return ((parent.window || window) as any).im.setGroupMemberRole(groupKey, key);
    }
  };

  //------------------window.sjb
  static sjb = {
    /**
     * 在聊天窗口打开指定tab
     */
    openTabInChat(tabId: string) {
      return ((parent.window || window) as any).sjb.openTabInChat(tabId);
    },
    /**
     * 激活聊天窗口
     */
    activeChat() {
      return ((parent.window || window) as any).sjb.activeChat();
    },
    /**
     * 获取应用程序名称
     */
    getAppName() {
      return ((parent.window || window) as any).sjb.getAppName();
    },
    /**
     * 获取应用程序安装路径
     */
    getAppPath() {
      return (window as any).sjb.getAppPath();
    },
    /**
     * 设置应用程序名称（禁用）
     */
    setAppName(appname: string) {
      return ((parent.window || window) as any).sjb.setAppName(appname);
    },
    /**
     * 刷新配置
     */
    refreshConfig() {
      ((parent.window || window) as any).sjb.refreshConfig();
    },
    /**
     * 重启客户端
     * @param args
     */
    restart(args: string) {
      ((parent.window || window) as any).sjb.restart(args);
    },
    /**
     * 图片预览
     * @param imgSrcs //JSON.stringify({ imgArr: this.imgs, imgIndex: index });
     * @param width 窗口宽度
     * @param height 窗口高度
     */
    viewImg(imgSrcs: string, width: number, height: number) {
      ((parent.window || window) as any).sjb.viewImg(imgSrcs, width, height);
    },
    /**
     * 获取应用程序安装 磁盘 格式   D:
     */
    getAppPath_Disk() {
      let appPath = ((parent.window || window) as any).sjb.getAppPath();
      return appPath.substr(0, 2)
    },
    /**
     *  获取本地文件信息
     *  入参支持相对路径
     */
    getFileInfos(files: string[], categoryId: number = Category.Document, useFileThumb = false) {
      let obj = ((parent.window || window) as any).localfile.hasOwnProperty("getFileInfos") ? ((parent.window || window) as any).localfile : ((parent.window || window) as any).md;
      let infos = obj.getFileInfos(JSON.stringify(files), categoryId, useFileThumb);
      return infos === "failed" ? [] : JSON.parse(infos);
    },
  };

  //---------------window.tools
  static tools = {
    /**
     * 获取已装插件列表
     * 输出：[{SoftKey,SoftID,FilePath}]
     */
    getInstalledTools() {
      const res = ((parent.window || window) as any).tools.getInstalledTools();
      return res == "failed" ? [] : JSON.parse(res);
    },

    /**
     * 安装插件
     * 入参：{Name,FilePath,SoftKey,SoftID,LogoPath}
     */
    install(contents: any) {
      return ((parent.window || window) as any).tools.install(JSON.stringify(contents));
    },

    /**
     * 更新
     *入参：{Name,FilePath,SoftKey,SoftID,LogoPath}
     */
    upgrade(contents: any) {
      return ((parent.window || window) as any).tools.upgrade(JSON.stringify(contents));
    },

    /**
     * 卸载插件
     */
    uninstall(softKey: string, softId: string) {
      return ((parent.window || window) as any).tools.uninstall(softKey, softId);
    },

    /**
     * 获取配置
     */
    getConfig() {
      const res = ((parent.window || window) as any).tools.getConfig();
      if (res == "failed") message.warning("获取配置失败！");
      return res == "failed" ? [] : JSON.parse(res);
    },

    /**
     * 保存配置
     */
    saveConfig(contents: any) {
      return ((parent.window || window) as any).tools.saveConfig(JSON.stringify(contents));
    },

    /**
     * 打开插件
     */
    open(softKey: string, softFilePath: string) {
      return ((parent.window || window) as any).tools.open(softKey, softFilePath);
    },

    /**
     * 安装SolidWorks插件
     */
    registerSwTool() {
      return ((parent.window || window) as any).tools.registerSwTool();
    },

    /**
     * 安装迈迪文件模板
     */
    installMdFileTemplate() {
      return ((parent.window || window) as any).tools.installMdFileTemplate();
    },

    /**
     * 安装焊接轮廓库
     */
    installHJLKLib() {
      return ((parent.window || window) as any).tools.installHJLKLib();
    },

    /**
     * 安装迈迪材质库
     */
    installMdMaterialLib() {
      return ((parent.window || window) as any).tools.installMdMaterialLib();
    },

    /**
     * 驱动模型
     */
    driveModel(modelData: any, callback: Function) {
      let callbackName = `driveModelCallback${UtilService.Guid()}`;
      Listener.add(callbackName, callback);
      return ((parent.window || window) as any).tools.driveModel(JSON.stringify(modelData), callbackName);
    },

    /**
     * 驱动step模型
     */
    driveStep(modelData: any) {
      return ((parent.window || window) as any).tools.driveStep(JSON.stringify(modelData));
    },
    /**
     * 设置文件修改时间
     */
    setFileModifyDate(paths: any[]) {
      ((parent.window || window) as any).localfile.setFileModifyDate(JSON.stringify(paths))
    },

    /**
     * SolidWorks判断
     * @param fn 
     */
    downModelCheck(fn: Function) {
      ((parent.window || window) as any).tools.downModelCheck(UtilService.RegisterWinFunc(fn));
    },

    /**
     * 判断SolidWorks是否打开
     * @returns 
     */
    checkSWOpen() {
      return (window as any).tools.checkSWOpen();
    }
  };
}

Object.keys(WinForm).forEach(_item => {
  const winObject = (WinForm as any)[_item];
  Object.keys(winObject).forEach(func => {
    const origin = winObject[func];
    winObject[func] = (...args: any[]) => {
      if (!(window as any)[_item]) {
        // throw `当前不支持window.${_item}`;
        (window as any).md && (console.error(`当前不支持window.${_item}`))
      }
      else {
        return origin(...args);
      }
    }
  });
});